<template>
    <img ref="img"
         :src="src"
         :height="calcH"
         :width="calcW" class="img-obj"/>
</template>

<script>
export default {
    name: "Image1",
    data () {
        return {
            calcW: this.width,
            calcH: this.height
        }
    },
    props: {
        src: String,
        scale: {
            default: "",
            type: String
        },
        height: {
            default: "100%",
            type: String
        },
        width: {
            default: "100%",
            type: String
        },
    },
    mounted () {
        let val = this.scale.split(":")
        if (val.length === 2) {
            if (Number(this.$refs["img"].clientWidth)) {
                this.calcH = Number(this.$refs["img"].clientWidth) * (val[1] / val[0]) + "px"
            }
        }
    }
}
</script>

<style scoped>
	.img-obj{
		object-fit: cover;
	}
</style>
